import "./wdyr";
import ReactDOM from "react-dom";
import App from "./App";
import "@fontsource/roboto/latin-400.css";
import "@fontsource/roboto/latin-700.css";

ReactDOM.render(<App />, document.getElementById("root"));
